import { Wallet, utils } from 'ethers';
// @ts-ignore
import keccak256         from 'keccak256';
import { MerkleTree }    from '../thirdParty/merkleTree';

const executeAbi = ["function execute(address _to, uint256 _value, bytes _data) public returns (uint256 executionId)"];
const executeInterface = new utils.Interface(executeAbi);


function getMerkleRootAndProofs(msgs: any[]) {
    const leaves = msgs.map(getMessageHash);
    // @ts-ignore
    const tree : MerkleTree = new MerkleTree(leaves, keccak256);
    const root : string | Buffer = tree.getRoot();
    const proofs = leaves.map((leaf : Uint8Array) => {
        return tree.getProof(leaf)
            .map((x) => utils.hexlify(x.data))
    });
    return {
        root,
        proofs
    }
}

function getMessageHash(msg: any): Uint8Array {
    const {
        from,
        to,
        value,
        data,
        nonce,
        gasPrice,
        gasToken,
        gasLimit,
        operationType,
    } = msg;
    const hash = utils.solidityKeccak256(
        ['address', 'address', 'uint256', 'bytes', 'uint', 'uint', 'address', 'uint', 'uint256'],
        [from, to, value, utils.keccak256(data), nonce, gasPrice, gasToken, gasLimit, operationType]
    );
    return utils.arrayify(hash);
}

function signMessage(privateKey: string, messageHash: string | Buffer) {
    const wallet = new Wallet(privateKey);
    return wallet.signMessage(messageHash);
}

export function getComposedTransactions(msg: any) {
    const {abi, args, delegation, executionSource, executionTarget, value} = msg;
    const innerContractInterface = new utils.Interface([abi]);
    const functions = innerContractInterface.functions;
    const name = Object.keys(functions)[0];
    const functionArgs = functions[name].inputs.map(arg => arg.name);
    const innerData = functions[name].encode(args);
    const newMsg = generateDataFields(executionTarget, delegation, value, innerData);
    return {
        ...msg,
        ...newMsg,
        from: executionSource,
        functionCalled: {
            name,
            args: functionArgs
        }
    }
}

function generateDataFields(to: string, delegation: any[], value: any, data: any): any {
    if (delegation.length === 0) {
        return {
            to,
            data
        }
    }
    const newData = executeInterface.functions.execute.encode([to, value, data]);
    const newTo = delegation.pop();
    return generateDataFields(newTo, delegation, value, newData);
}


export async function getSignedTransactions(privateKey: string, msgs: any[], nonce: number) {
    const newMsgs = msgs.map((msg, index) => {
        return {
            ...msg,
            nonce: nonce + index
        }

    });

    const {root, proofs} = getMerkleRootAndProofs(newMsgs);

    return signMessage(privateKey, root)
        .then(rootSignatures => {
            return newMsgs.map((msg, index) => ({
                ...msg,
                rootSignatures: rootSignatures,
                merkleProof: proofs[index],
            }));
        }).catch(err => {
            throw err;

        })
}
